import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedProducts from "./components/FeaturedProducts";
import ReviewsSection from "./components/ReviewsSection";
import CompanySection from "./components/CompanySection";
import { Link } from "react-router-dom";

const HomePage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Navbar />
    <HeroSection />
    <CategoriesSection />
    <FeaturedProducts />
    <ReviewsSection />
    <CompanySection />
    {/* CTA */}
    <section className="py-20 bg-orange-500">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4">Ready to Get to Work?</h2>
        <p className="text-orange-100 text-lg mb-8">Browse 30 professional-grade tools. Secure Stripe checkout. Fast shipping.</p>
        <Link to="/products" className="inline-flex items-center gap-2 px-10 py-4 bg-white text-orange-600 font-bold rounded-lg hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap text-lg">
          Shop All Products <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
    <Footer />
  </div>
);

export default HomePage;
